import React, {useState} from 'react';
import './index.css';
import {directionDegrees} from "../../config/config";

interface P {
    value: {label: string, value: number}
    onChange: (newOri: {label: string, value: number}) => void;
    label: string
    i18nMap: any
}

export default ({ value, onChange, label, i18nMap, }: P) => {

    const [togglePicker, setTogglePicker] = useState<boolean>(false);

    return (
        <div className={`pie-items`}>

            {!togglePicker && <div className={`pie-label`}>
                {label}
            </div>}

            <div className={`pie-items-center non-selectable ${togglePicker && 'center-toggled'}`} onClick={() => setTogglePicker(!togglePicker)}>
                {i18nMap[value.label] || '?'}
            </div>

            {directionDegrees.map((ori, i) =>
                <div key={i} className={`pie-item ${ori.value === value.value && 'pie-toggled'} toggled-${togglePicker ? `${ori.direction} pie-item-shown` : ''} non-selectable`}
                     onClick={() => {
                         onChange(ori);
                         setTogglePicker(false);
                     }}>
                    {i18nMap[ori.label]}
                </div>
            )}

        </div>
    );
}